import React, { useEffect, useState } from 'react'
import { Text, View, TextInput, StyleSheet, Alert, Pressable } from 'react-native'
import { Image } from 'expo-image'
import { Feather, Ionicons } from '@expo/vector-icons'
import { getLanguage } from '../../appBar/context/LocalizationContext'
import { FormFieldsModel, ModelAnswerFromProps } from '../models/StoreDetailModel'
import { TouchableOpacity } from 'react-native-gesture-handler'
import * as ImagePicker from 'expo-image-picker'
import { useBottomSheet } from '../../customUtils/context/BottomSheetContext'
import { PhotoModal } from '../FormItems/InputPhotoItem'
import { getImageStogeUrl } from '../../imageUploader/ImageStorage'
import styles from '../FormItems/InputPhotoItemStyles'
import theme from '../../../../theme'
import { schedulesServices } from '../../../../database/schedules.database'
import { updateFormAnswerSchedule } from '../../../../db-sqlite/repositories/schedule.repository'
import {
    eventEmitter,
    get_url_save_photo,
} from '../../../utils/functions.utils'
import { getConection } from '../../appBar/context/HeaderContext'

interface InputPhotoFieldProps {
    item: FormFieldsModel
    hasCamera: boolean
    hasGalery: boolean
    form_id: string
    schedule_id: string
    store_id: string
    answerProp: ModelAnswerFromProps
    answers?: ModelAnswerFromProps[]
    checkComplete: (option?: ModelAnswerFromProps) => void
    saveItemSteps?: (option: ModelAnswerFromProps) => void
}

export const InputPhotoField = ({
    item,
    hasCamera,
    hasGalery,
    form_id,
    answerProp,
    answers,
    schedule_id,
    store_id,
    checkComplete,
    saveItemSteps,
}: InputPhotoFieldProps) => {
    // console.log('InputPhotoField ~ answerProp:', answerProp)
    // console.log('InputPhotoField ~ item:', item)
    // const { openBottomSheet, closeBottomSheet } = useBottomSheet()
    const [image, setImage] = useState<string | null>(null)
    const { isConnected, hasInternet } = getConection()
    const { languageFile } = getLanguage()
    const placeHolder = require('../../../../assets/placeholderImage.png')

    useEffect(() => {
        // answerProp es la respuesta a nivel de la pregunta padre y se comparte entre
        // TODOS los fields de la acción (ej: dos fields de foto en la misma pregunta),
        // así que no sirve para restaurar la foto de este field en particular.
        // Cada field guarda su propia fila en `answers`, keyeada por su _id sintético
        // (ver DropdownField.findSavedAnswer / usePonderateGroup.getFieldSavedText) —
        // si no está ahí, y answerProp sí es la respuesta de este field puntual, la usamos.
        const savedAnswer =
            (answers ?? []).find((a) => a && item._id && a._id === item._id) ??
            (item._id && answerProp?._id === item._id ? answerProp : undefined)

        if (savedAnswer?.field_media && savedAnswer.field_media !== '') {
            const localUri = savedAnswer?.pickerResult_uri
            if (localUri && (localUri.startsWith('file://') || localUri.includes('https'))) {
                // URI local del dispositivo o URL completa — usar directo
                setImage(localUri)
            } else {
                // Solo S3 key — obtener URL firmada (fallback más lento)
                const key = savedAnswer.field_media
                getImageStogeUrl(key).then((url) => {
                    if (url) setImage(url)
                })
            }
        }
    }, [])

    const handleImagePickerResult = async (photoUri: string) => {
        eventEmitter.emit('process_start_image')
        if (photoUri) {
            let answer: ModelAnswerFromProps = null
            try {
                const res_get_url_save_photo = get_url_save_photo('/stores/form')
                const filename = res_get_url_save_photo
                if (saveItemSteps) {
                    answerProp = item as any
                }
                answer = {
                    _id: item?._id,
                    option_selected_text: answerProp?.option_selected_text,
                    option_selected_id: answerProp?.option_selected_id,
                    question_id: answerProp?.question_id,
                    media: '',
                    question_text: answerProp?.question_text,
                    // score: answerProp?.score ? answerProp?.score.toString() : '0', //borro y seteo score del field si tiene
                    score: item?.score ? item?.score.toString() : '0', // score del field
                    status: 1,
                    date_finish: new Date().toString(),
                    date_init: new Date().toString(),
                    question_input: '',
                    field_media: '',
                    field_text: '',
                    // questionScore: answerProp?.questionScore ?? 0, // borro y seteo score del field si tiene
                    questionScore: item?.questionScore ?? 0, // score del field
                    index: answerProp?.index ?? 0,
                    type: answerProp?.type,
                    ponderar: !!(item?.questionScore && item.questionScore > 0),

                    question: item?.label || item?.title || answerProp?.question_text,
                    questionOptionSelected: answerProp?.option_selected_id,
                    questionOptionSelectedText: answerProp?.option_selected_text,
                    questionType: (item as any)?.type ?? answerProp?.questionType,
                    questionPrice: '',
                    tag: '',
                    questionImage: '',
                    questionInput: '',

                    sku: answerProp?.sku,
                    description: answerProp?.description ?? '',
                    description_short: answerProp?.description_short ?? '',
                }

                answer.field_media = filename
                answer.media = filename
                answer.questionImage = filename
                answer.pickerResult_uri = photoUri

                await schedulesServices.savePendingImage(filename, photoUri)
                setImage(photoUri)
                if (form_id) {
                    // console.log('estoy en el caso de form_id: ', JSON.stringify(answer))
                    await checkComplete(answer)
                } else {
                    console.log('estoy en el caso de checkin')
                }
            } catch (error) {
                console.error('12 Error al subir la imagen:', error)
                eventEmitter.emit('process_end_image')
            } finally {
                try {
                    if (saveItemSteps) {
                        saveItemSteps(answer)
                    } else {
                        updateFormAnswerSchedule({
                            newAnswer: answer,
                            schedule_id,
                            form_id,
                            store_id,
                        })
                        await checkComplete(answer)
                    }
                } catch (e) {
                    eventEmitter.emit('process_end_image')
                    Alert.alert('Error', 'No se pudo subir la imagen', e)
                }
            }
        }
        eventEmitter.emit('process_end_image')
    }

    return (
        <>
            {image ? (
                <View>
                    {item?.label && <Text style={styles.title}>{item.label}</Text>}
                <View style={styles.containerGeneral}>
                    <View style={[styles.subContainer, { flex: 1.2 }]}>
                        <Image style={styles.imagePreview} source={image} />
                        <Text style={[styles.fileName, { flex: 1 }]}>
                            {languageFile.uploaded_image}
                        </Text>
                        <Ionicons
                            name={'checkmark-sharp'}
                            size={16}
                            color={theme.colors.colorApproved}
                        />
                    </View>
                    <View style={{ width: 12 }} />
                    <View>
                        <Pressable
                            onPress={() => setImage(null)}
                            style={styles.containerMiniButton}
                        >
                            <Text style={styles.textMiniButton}>
                                {languageFile.edit}
                            </Text>
                            <Feather
                                name='edit-2'
                                size={12}
                                color={theme.colors.colorPrimary}
                                style={styles.marginLeft}
                            />
                        </Pressable>
                    </View>
                </View>
                </View>
            ) : (
                <View>
                    <View style={styles.container}>
                        <PhotoModal
                            hasCamera={hasCamera}
                            hasGalery={hasGalery}
                            handleImagePickerResult={handleImagePickerResult}
                            field={item}
                        />
                    </View>
                </View>
            )}
        </>
    )
}
